import React, { useState, useRef, useEffect } from "react";

const WaMeLink = () => {

    const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
    const waLink = `https://wa.me/${whatsappNumber}`;

    const [pos, setPos] = useState({ x: null, y: null });
    const [dragging, setDragging] = useState(false);
    const dragStart = useRef(null);
    const posRef = useRef(pos);
    const didMove = useRef(false);
    const SIZE = 56;
    const MARGIN = 12;

    // Inicializar posición: esquina inferior derecha
    useEffect(() => {
        const x = window.innerWidth - SIZE - MARGIN;
        const y = window.innerHeight - SIZE - MARGIN;
        setPos({ x, y });
        posRef.current = { x, y };
    }, []);

    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

    const startDrag = (clientX, clientY) => {
        didMove.current = false;
        dragStart.current = {
            mouseX: clientX,
            mouseY: clientY,
            elemX: posRef.current.x,
            elemY: posRef.current.y,
        };
        setDragging(true);
    };

    const onDrag = (clientX, clientY) => {
        if (!dragStart.current) return;
        const dx = clientX - dragStart.current.mouseX;
        const dy = clientY - dragStart.current.mouseY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) didMove.current = true;
        const x = clamp(dragStart.current.elemX + dx, MARGIN, window.innerWidth - SIZE - MARGIN);
        const y = clamp(dragStart.current.elemY + dy, MARGIN, window.innerHeight - SIZE - MARGIN);
        setPos({ x, y });
        posRef.current = { x, y };
    };

    const endDrag = () => {
        dragStart.current = null;
        setDragging(false);
    };

    // Mouse
    useEffect(() => {
        const onMouseMove = (e) => { if (dragging) onDrag(e.clientX, e.clientY); };
        const onMouseUp = () => { if (dragging) endDrag(); };
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [dragging]);

    // Touch
    const onTouchStart = (e) => {
        const t = e.touches[0];
        startDrag(t.clientX, t.clientY);
    };
    const onTouchMove = (e) => {
        e.preventDefault();
        const t = e.touches[0];
        onDrag(t.clientX, t.clientY);
    };
    const onTouchEnd = () => endDrag();

    const handleClick = (e) => {
        if (didMove.current) e.preventDefault();
    };

    if (pos.x === null) return null;

    return (
        <div
            style={{
                position: "fixed",
                left: pos.x,
                top: pos.y,
                width: SIZE,
                height: SIZE,
                cursor: dragging ? "grabbing" : "grab",
                userSelect: "none",
                zIndex: 50,
                transition: dragging ? "none" : "box-shadow 0.2s",
                filter: dragging ? "drop-shadow(0 6px 16px rgba(0,0,0,0.25))" : "drop-shadow(0 2px 6px rgba(0,0,0,0.15))",
            }}
            onMouseDown={(e) => { e.preventDefault(); startDrag(e.clientX, e.clientY); }}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
        >
            <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                draggable={false}
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/960px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    draggable={false}
                    style={{ width: SIZE, height: SIZE, display: "block" }}
                />
            </a>
        </div>
    );
};

export default WaMeLink;